<template>
  <div class="h-full  rounded-lg flex flex-col gap-2">
    <div v-if="showPopup" class="p-confirm-popup">
      <div class="p-confirm-popup-content">
        <p>{{ popupMessage }}</p>
        <div class="p-confirm-popup-footer">
          <button class="p-button p-confirm-popup-accept" @click="confirmPopup">
            Sim
          </button>
          <button class="p-button p-confirm-popup-reject" @click="cancelPopup">
            Não
          </button>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2 overflow-y-auto scrollbar-thin scrollbar-tema">
      <div class="flex flex-col  md:flex-row gap-2 ">
        <AppEquipamentosForm :podeGerir="podeGerir" :show="show_form_equip" :form_title="form_title" :form_data="equipamento_formData"
          :create_btn="create_equipamento_" :set_data="equipamento_setData" :precoEquipamento="precoEquipamento"
          @close="closeForm" @create="create_equipamento" @update="update_equipamento" @disable="disable_equipamento"
          @replica="replica_equipamento" />

        <AppGpsForm :podeGerir="podeGerir" :show="show_form_gps" :form_title="form_title" :form_data="gps_formData" :create_btn="create_gps_"
          :set_data="gps_setData" @close="closeForm" @create="create_gps" @update="update_gps" @disable="disable_gps" />

        <AppTpaForm :podeGerir="podeGerir" :show="show_form_tpa" :form_title="form_title" :form_data="tpa_formData" :create_btn="create_tpa_"
          :set_data="tpa_setData" @close="closeForm" @create="create_tpa" @update="update_tpa" @disable="disable_tpa" />

        <AppComputadorForm :podeGerir="podeGerir" :show="show_form_comp" :form_title="form_title" :form_data="comp_formData"
          :create_btn="create_comp_" :set_data="comp_setData" @close="closeForm" @create="create_comp"
          @update="update_comp" @disable="disable_comp" />
      </div>
      <div class="w-full flex flex-col gap-2 h-full">
        <EquipamentoFilter v-if="showEquipamentoFilter" @filtersChanged="updateFilters" @close-filter="showEquipamentoFilter = false"/>
        <div class="h-full">

         <GenericDataTable
          v-if="validPermission('E0006') && show_equip"
          ref="dataTableRef"
          @row-click="select_equipamento"
          :api-url="`${baseURl}/api/v1/equipamento/pagination/`"
          :useServerSide="true"
          :columns="equipamentoColumns"
          :preserve-api-order="true"
          :initial-params="currentFilters"
          :show_export="true"
          :show_close_btn="false"
          table_title="Equipamentos"
        >
          <template #left-actions>
            <button
              class="action-btn filter-btn"
              @click="showEquipamentoFilter  = !showEquipamentoFilter"
              title="Filtros"
            >
              <i class="fa-solid fa-filter"></i>
            </button>
            <button
              v-if="(podeGerir) && validPermission('E0003')"
              class="action-btn filter-btn"
              @click="triggerAction({ action: 'create_equipamento' })"
              title="Adicionar"
            >
              <i class="fa-solid fa-circle-plus fa-xl"></i>
            </button>
          </template>
        </GenericDataTable>
        </div>


        <!-- <AppPaginationTable :visibility="this.validPermission('E0006')" :show="show_equip" :filterBtn="true"
          :refresh="refresh_table" :table_title="table_title" :data="filter_data" :url-string="urlString"
          :AddRemoveBtn="{ verGPS: true, verTPA: true, verComputador: true, verAdicionar: true }"
          @open-tpa="muda_tpa" @open-gps="muda_gps" @open-computador="muda_comp"
          @open-adicionar="triggerAction({ action: 'create_equipamento' })" @open-filter="showEquipamentoFilter = true"
          @row-clicked="select_equipamento" @delete_data="remove_equipamento" @refreshed="checkAndResetRefreshTable" /> -->
        <!-- <AppPaginationTable :visibility="this.validPermission('E0006')" :show="show_gps" :refresh="refresh_table"
          :table_title="table_title" :url-string="urlString"
          :AddRemoveBtn="{ verEquipamento: true, verTPA: true, verComputador: true, verAdicionar: TrainFrontTunnelIcon }"
          @open-equipamento="muda_equip" @open-tpa="muda_tpa" @open-computador="muda_comp"
          @open-adicionar="triggerAction({ action: 'create_gps' })" @row-clicked="select_gps" @delete_data="remove_gps"
          @refreshed="checkAndResetRefreshTable" />
        <AppPaginationTable :visibility="this.validPermission('E0006')" :show="show_tpa" :refresh="refresh_table"
          :table_title="table_title" :url-string="urlString"
          :AddRemoveBtn="{ verEquipamento: true, verGPS: true, verComputador: true, verAdicionar: true }"
          @open-equipamento="muda_equip" @open-gps="muda_gps" @open-computador="muda_comp"
          @open-adicionar="triggerAction({ action: 'create_tpa' })" @row-clicked="select_tpa" @delete_data="remove_tpa"
          @refreshed="checkAndResetRefreshTable" />
        <AppPaginationTable :visibility="this.validPermission('E0006')" :show="show_comp" :refresh="refresh_table"
          :table_title="table_title" :url-string="urlString"
          :AddRemoveBtn="{ verEquipamento: true, verGPS: true, verTPA: true, verAdicionar: true }"
          @open-equipamento="muda_equip" @open-gps="muda_gps" @open-tpa="muda_tpa"
          @open-adicionar="triggerAction({ action: 'create_comp' })" @row-clicked="select_comp"
          @delete_data="remove_comp" @refreshed="checkAndResetRefreshTable" /> -->
      </div>
    </div>
    <!-- <EquipamentoFilter v-if="showEquipamentoFilter" :data="filter_data" @save="set_filter"
      @close="showEquipamentoFilter = false" /> -->
  </div>
</template>

<script>
import axios from "axios";
import AppEquipamentosForm from "@/components/forms/equipamento/equipamentosForm.vue";
import AppGpsForm from "@/components/forms/equipamento/GpsForm.vue";
import AppTpaForm from "@/components/forms/equipamento/TpaForm.vue";
import AppComputadorForm from "@/components/forms/equipamento/ComputadorForm.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { toast } from "vue3-toastify";
import permissionMixin from "@/permissionMixin.js";
import { podeGerirFamiliasEquipamentos } from "@/utils/valencias";
// import AppPaginationTable from "@/components/tablePagination/tablePagination.vue";
// import EquipamentoFilter from "@/components/popUps/equipamentoFilter.vue";
import GenericDataTable from "@/components/dataTable/GenericDataTable2.vue";
import EquipamentoFilter from "@/components/filterDataTable/equipamentoFilter.vue";

export default {
  mixins: [permissionMixin],
  name: "appequipamentos",
  components: {
    AppEquipamentosForm,
    AppGpsForm,
    AppTpaForm,
    AppComputadorForm,
    // AppPaginationTable,
    EquipamentoFilter,
    GenericDataTable
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      // Sem a valência "Gerir famílias e equipamentos" o ecrã fica só de
      // consulta: os botões de criar/editar/desativar não aparecem e o
      // backend recusa a escrita de qualquer forma.
      podeGerir: false,
      current_table: "none",
      show_form_equip: false,
      show_form_gps: false,
      show_form_tpa: false,
      show_form_comp: false,
      show_equip: true,
      show_gps: false,
      show_tpa: false,
      show_comp: false,
      form_title: "No Title",
      create_equipamento_: false,
      create_tpa_: false,
      create_gps_: false,
      create_comp_: false,
      refresh_table: false,

      resp_status: 0,
      resp_msg: '',

      filter_data: {
        "codigo": "",
        "nome": "",
        "status": [],
        "marca": [{ "id": 1, "nome": "Sem Marca", "status": "Ativo" }],
        "servico": [{ "id": 0, "nome": "Sem Serviço", "abreviatura": "SS", "valorizacao": false, "status": "ativo" }],
        "medida": [],
        "produto": [],
        "tipologia": [],
        "familia": [],
        "fields": "id,nome,familia,status,produto,tipologia,marca,medida,referencia,servico,codigo"
      },

      equipamento_formData: {
        id: 0,
        codigo: '',
        nome: '',
        descricao: '',
        referencia: '',
        foto: require("@/assets/car_logo.svg"),
        status: '',
      },

      equipamento_setData: {
        familia: { id: 0, nome: '' },
        produto: { id: 0, produto: '' },
        tipologia: { id: 0, nome: '' },
        marca: { id: 0, nome: '' },
        preco: { id: 0, venda: 0 },
        medida: { id: 0, nome: '' },
        servico: { id: 0, nome: '' },
      },

      gps_formData: {
        id: 0,
        nome: '',
        modelo: '',
        ip: '',
        simCard: '',
        tipoComm: '',
        status: ''
      },

      gps_setData: {
        viatura: { id: 0, matricula: '' },
      },

      tpa_formData: {
        id: 0,
        nome: '',
        modelo: '',
        serie: '',
        simCard: '',
        banco: '',
        status: ''
      },

      tpa_setData: {
        utilizador: { id: 0, nome: '' },
      },

      comp_formData: {
        id: 0,
        codigo: '',
        modelo: '',
        tipoComm: '',
        simCard: '',
        ip: '',
        status: ''
      },

      comp_setData: {
        utilizador: { id: 0, nome: '' },
      },

      //   FilterForm data
      tabela: "equipamento",
      table_title: "equipamentos",
      currentType: "",
      showPopup: false,
      popupMessage: "",
      resolvePopup: null,
      showEquipamentoFilter: false,
      filter_data: {},
      urlString: "equipamento/tablefilter",
      precoEquipamento: {},
      currentFilters: {},
      equipamentoColumns:[
        {
          key: 'familia.nome',
          label: 'Família',
          type: 'text',
          maxWidth: 100,
        },
        {
          key: 'codigo',
          label: 'Código',
          type: 'text',
          maxWidth: 150,
        },
        {
          key: 'nome',
          label: 'Nome',
          type: 'text',
          maxWidth: 200,
        },
        {
          key: 'produto.nome',
          label: 'Produto',
          type: 'text',
          maxWidth: 100,
        },
        {
          key: 'tipologia.nome',
          label: 'Tipologia',
          type: 'text',
          maxWidth: 100,
        },
        {
          key: 'marca.nome',
          label: 'Marca',
          type: 'text',
          maxWidth: 100,
        },
        {
          key: 'medida.nome',
          label: 'Medida',
          type: 'text',
          maxWidth: 100,
        },
        {
          key: 'referencia',
          label: 'Referência',
          type: 'text',
          maxWidth: 120,
        },
        {
          key: 'servico.nome',
          label: 'Serviço',
          type: 'text',
          maxWidth: 100,
        },
        {
          key: 'status',
          label: 'Status',
          type: 'badge',
          maxWidth: 90,
        },
      ]
    };

  },

  async created() {
    this.podeGerir = await podeGerirFamiliasEquipamentos();
    this.filter_data = {
      "codigo": "",
      "nome": "",
      "status": [],
      "marca": [{ "id": 1, "nome": "Sem Marca", "status": "Ativo" }],
      "servico": [{ "id": 0, "nome": "Sem Serviço", "abreviatura": "SS", "valorizacao": false, "status": "ativo" }],
      "medida": [],
      "produto": [],
      "tipologia": [],
      "familia": [],
      "fields": "id,nome,familia,status,produto,tipologia,marca,medida,referencia,servico,codigo"
    }
  },

  methods: {
     updateFilters(filters) {
      this.currentFilters = { ...filters };
      this.refreshTable();
    },

    // A tabela nova (GenericDataTable) não observa o flag refresh_table,
    // por isso qualquer criação/edição/desativação tem de a refrescar aqui.
    refreshTable() {
      this.$refs.dataTableRef?.refresh();
    },
    set_default_Filter() {
      const deffl = {
        "codigo": "",
        "nome": "",
        "status": [],
        "marca": [{ "id": 1, "nome": "Sem Marca", "status": "Ativo" }],
        "servico": [{ "id": 0, "nome": "Sem Serviço", "abreviatura": "SS", "valorizacao": false, "status": "ativo" }],
        "medida": [],
        "produto": [],
        "tipologia": [],
        "familia": [],
        "fields": "id,nome,familia,status,produto,tipologia,marca,medida,referencia,servico,codigo"
      }
      this.urlString = "equipamento/tablefilter";
      this.filter_data = deffl;
      this.showEquipamentoFilter = false;
      this.refresh = true;
    },


    set_filter(data) {
      console.log(data)
      this.urlString = "equipamento/tablefilter";
      this.filter_data = JSON.parse(JSON.stringify(data));
      this.showEquipamentoFilter = false;
      this.refresh = true;
    },
    showConfirm(message) {
      return new Promise((resolve) => {
        this.popupMessage = message;
        this.showPopup = true;
        this.resolvePopup = resolve; // Store the resolve function
      });
    },
    confirmPopup() {
      if (this.resolvePopup) {
        this.resolvePopup(true); // Resolve the promise with true
      }
      this.hidePopup();
    },
    cancelPopup() {
      if (this.resolvePopup) {
        this.resolvePopup(false); // Resolve the promise with false
      }
      this.hidePopup();
    },
    hidePopup() {
      this.showPopup = false;
      this.popupMessage = "";
      this.resolvePopup = null; // Reset resolvePopup to avoid future issues
    },

    muda_comp() {
      this.urlString = "computador";
      this.table_title = 'Computadores'
      this.show_gps = false;
      this.show_tpa = false;
      this.show_equip = false;
      this.show_comp = true;
    },

    muda_tpa() {
      this.urlString = "tpa";
      this.table_title = 'Terminias de Pagamento'
      this.show_gps = false;
      this.show_tpa = true;
      this.show_equip = false;
      this.show_comp = false;
    },

    muda_gps() {
      this.urlString = "gps";
      this.table_title = 'GPS'
      this.show_gps = true;
      this.show_tpa = false;
      this.show_equip = false;
      this.show_comp = false;
    },

    muda_equip() {
      this.urlString = "equipamento/tablefilter";
      this.table_title = 'Equipamentos'
      this.show_gps = false;
      this.show_tpa = false;
      this.set_default_Filter();
      this.show_equip = true;
      this.show_comp = false;
    },



    checkAndResetRefreshTable() {
      if (this.refresh_table === true) {
        this.refresh_table = false;
      }
    },

    async create_gps(data) {
      try {
        let create_data = this.setGpsData(data);
        let res = await this.create(create_data, `${this.baseURl}/api/v1/gps/registrar/`);
        if (res) {
          this.refresh_table = true;
          this.closeForm();
          toast.success("Gps criado com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 800,
          });
        } else {
          // Handle unexpected cases where res is not as expected
          toast.error("Erro inesperado ao criar Gps", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
      } catch (error) {
        // Handle the error by extracting the message from the error response
        console.error("Erro ao criar Gps:", error);
        let errorMessage = "Erro ao criar Gps";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },

    async create_tpa(data) {
      try {
        let create_data = this.setTpaData(data);
        let res = await this.create(create_data, `${this.baseURl}/api/v1/tpa/registrar/`
        );
        if (res) {
          this.refresh_table = true;
          this.closeForm();
          toast.success("Tpa criado com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 800,
          });
        } else {
          // Handle unexpected cases where res is not as expected
          toast.error("Erro inesperado ao criar Tpa", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
      } catch (error) {
        // Handle the error by extracting the message from the error response
        console.error("Erro ao criar Tpa:", error);
        let errorMessage = "Erro ao criar Tpa";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },

    async create_computador(data) {
      try {
        let create_data = this.setCompData(data);
        let res = await this.create(create_data, `${this.baseURl}/api/v1/computador/registrar/`
        );
        if (res) {
          this.refresh_table = true;
          this.closeForm();
          toast.success("Computador criado com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 800,
          });
        } else {
          // Handle unexpected cases where res is not as expected
          toast.error("Erro inesperado ao criar Computador", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
      } catch (error) {
        // Handle the error by extracting the message from the error response
        console.error("Erro ao criar Computador:", error);
        let errorMessage = "Erro ao criar Computador";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },

    async create_equipamento(data, precoEquipamento) {
      try {
        let create_data = this.setEquipamentoData(data);
        let res = await this.create(create_data, `${this.baseURl}/api/v1/equipamento/registrar/`
        );
        if (res && res.require_confirmation) {
          const confirmCreate = await this.showConfirm(
            "Este Equipamento não tem o Equipamento Sem Marca. Deseja criar?"
          );
          if (confirmCreate) {
            create_data.confirmation = "true";
            res = await this.create(create_data, `${this.baseURl}/api/v1/equipamento/registrar/`);
          } else {
            create_data.confirmation = "false";
            res = await this.create(create_data, `${this.baseURl}/api/v1/equipamento/registrar/`);
          }
        }
        if (res) {
          const equipamentos = res;
          for (let i = 0; i < equipamentos.length; i++) {
            const equipamento = equipamentos[i];
            try {
              const basePrecoEquipamento = i === equipamentos.length - 1 ? precoEquipamento : precoEquipamento;
              // Create a deep copy of the basePrecoEquipamento
              const currentPrecoEquipamento = JSON.parse(
                JSON.stringify(basePrecoEquipamento)
              );
              // If not the last equipamento, set prices to zero
              if (i !== equipamentos.length - 1) {
                currentPrecoEquipamento.compraAtual = 0;
                currentPrecoEquipamento.compraMed = 0;
                currentPrecoEquipamento.compraMin = 0;
                currentPrecoEquipamento.venda = 0;
                currentPrecoEquipamento.vendaMin = 0;
              }
              // Update the equipamento_id in the current precoEquipamento
              currentPrecoEquipamento.equipamento_id = equipamento.id;
              // Upload image for the current equipamento
              data.id = equipamento.id;
              this.upload_img(data);
              // Create itemprecario for the current equipamento
              const precoResponse = await this.create(
                currentPrecoEquipamento,
                `${this.baseURl}/api/v1/itemprecario/registrar/`
              );
              console.log(`Itemprecario criado para equipamento ${equipamento.id}:`, precoResponse);
            } catch (err) {
              console.error(`Erro ao processar equipamento ${equipamento.id}:`, err);
              // Handle error for this specific equipamento
              toast.error(`Erro ao criar itemprecario para o equipamento ${equipamento.id}`,
                {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 800,
                }
              );
            }
          }
          this.refresh_table = true;
          this.closeForm();
          this.refreshTable();
          // Display success message based on the number of equipamentos created
          if (equipamentos.length === 1) {
            toast.success("Equipamento criado com sucesso", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 800,
            });
          } else {
            toast.success("Equipamentos criados com sucesso", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 800,
            });
          }
        } else {
          // Handle unexpected cases where res is not as expected
          toast.error("Erro inesperado ao criar equipamento", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 1000,
          });
        }
      } catch (error) {
        // Handle the error by extracting the message from the error response
        console.error("Erro ao criar equipamento:", error);
        let errorMessage = "Erro ao criar equipamento";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
      }
    },




    async get_imagem(id) {
      if (id == 0) return;
      try {
        const response = await axios.get(
          `${this.baseURl}/api/v1/equipamento/foto/${id}/`,
          { responseType: "blob" }
        );
        // Create a local URL of the image
        this.equipamento_formData.foto = URL.createObjectURL(
          new Blob([response.data])
        );
      } catch (error) {
        console.log(error);
      }
    },
    async upload_img(formData) {


      if (formData.newFoto) {
        try {
          const response = await axios.post(
            `${this.baseURl}/api/v1/equipamento/editar/foto/${formData.id}/`,
            formData.newFoto,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          const filePath = response.data.filePath;
          //this.formData.foto = filePath;
          // await this.get_imagem(formData.id);

        } catch (error) {
          console.error("Error uploading file:", error);
        }

      }

    },
    async getPrecoEquipamento(equipamento_id) {
      const preco = await this.select(
        `${this.baseURl}/api/v1/itemprecario/?campo=equipamento_id&&valor=${equipamento_id}&&exact=true`
      );
      if (preco) {
        this.precoEquipamento = preco[0];
      }
    },

    async select_equipamento(data) {
      this.close_generic_table();
      this.create_equipamento_ = false;
      this.form_title = "Informação Do Equipamento";
      const equipamento = await this.select(`${this.baseURl}/api/v1/equipamento/${data.id}/`);
      await this.getPrecoEquipamento(data.id);
      if (equipamento) {
        this.setEquipamentoForm(equipamento);
        await this.get_imagem(data.id);
        this.show_form_equip = true;
      }
    },

    async select_tpa(data) {
      this.close_generic_table();
      this.create_tpa_ = false;
      this.form_title = "Informação De TPA";
      const tpa = await this.select(`${this.baseURl}/api/v1/tpa/${data.id}/`);
      console.log(tpa)
      if (tpa) {
        this.setTpaForm(tpa);
        this.show_form_tpa = true;
      }
    },

    async select_gps(data) {
      this.close_generic_table();
      this.create_gps_ = false;
      this.form_title = "Informação De GPS";
      const gps = await this.select(`${this.baseURl}/api/v1/gps/${data.id}/`);
      console.log(gps)
      if (gps) {
        this.setGpsForm(gps);
        this.show_form_gps = true;
      }
    },


    async select_comp(data) {
      this.close_generic_table();
      this.create_comp_ = false;
      this.form_title = "Informação Do Computador";
      const computador = await this.select(`${this.baseURl}/api/v1/computador/${data.id}/`);
      if (computador) {
        this.setCompForm(computador);
        this.show_form_comp = true;
      }
    },

    async update_comp(data, precoEquipamento) {
      let update_data = this.setCompData(data);
      const res = await this.update(`${this.baseURl}/api/v1/computador/editar/${data.id}/`, update_data);

      this.upload_img(data);
      if (res) {
        this.refresh_table = true;
        this.closeForm();
        toast.success("computador atualizado com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.log("response:", res);
        this.show_comp = true;
      } else {
        toast.error("Erro ao atualizar computador", {
          autoClose: 1000,
        });
      }
    },


    async update_tpa(data, precoEquipamento) {
      let update_data = this.setTpaData(data);
      const res = await this.update(`${this.baseURl}/api/v1/tpa/editar/${data.id}/`, update_data);

      this.upload_img(data);
      if (res) {
        this.refresh_table = true;
        this.closeForm();
        toast.success("tpa atualizada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.log("response:", res);
        this.show_tpa = true;
      } else {
        toast.error("Erro ao atualizar tpa", {
          autoClose: 1000,
        });
      }
    },


    async update_gps(data, precoEquipamento) {
      let update_data = this.setGpsData(data);
      const res = await this.update(`${this.baseURl}/api/v1/gps/editar/${data.id}/`, update_data);

      this.upload_img(data);
      if (res) {
        this.refresh_table = true;
        this.closeForm();
        toast.success("gps atualizada com sucesso", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        console.log("response:", res);
        this.show_gps = true;
      } else {
        toast.error("Erro ao atualizar gps", {
          autoClose: 1000,
        });
      }
    },

    async replica_equipamento(data, lista) {
      try {
        const res = await this.create(lista, `${this.baseURl}/api/v1/equipamento/replica/${data.id}/`);
        console.log("REPLICACAO CMO ", this.resp_status, this.resp_msg)
        if (this.resp_status == 200) {
          toast.success("Equipamento replicado com sucesso", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        } else if (this.resp_status == 208) {
          toast.success(this.resp_msg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        } else {
          toast.success("Erro a replicar marcas", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
        this.refresh_table = true;
        this.refreshTable();
      } catch (error) {
        console.log(error)
        toast.success(`Erro a replicar ${error}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    },

    async update_equipamento(data, precoEquipamento) {
      let update_data = this.setEquipamentoData(data);
      const res = await this.update(`${this.baseURl}/api/v1/equipamento/editar/${data.id}/`, update_data);
      if (!res) {
        // resp_msg traz o motivo do backend (ex.: código duplicado)
        toast.error(this.resp_msg || "Erro ao atualizar equipamento", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500,
        });
        return;
      }

      // O itemprecario só existe se o equipamento já tiver preçário associado
      if (precoEquipamento && precoEquipamento.id) {
        await this.update(`${this.baseURl}/api/v1/itemprecario/editar/${precoEquipamento.id}/`, precoEquipamento);
      }
      await this.upload_img(data);

      this.closeForm();
      this.refreshTable();
      toast.success("Equipamento atualizado com sucesso", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 1000,
      });
      this.show_equip = true;
    },

    async remove_equipamento(data) {
      const res = await this.remove(`${this.baseURl}/api/v1/equipamento/eliminar/${data.id}/`);
      if (res) {
        this.close_generic_table();
        this.closeForm();
        this.refresh_table = true;
      }
    },

    closeForm() {
      this.show_form_equip = false;
      this.show_form_gps = false;
      this.show_form_tpa = false;
      this.show_form_comp = false;
      this.close_generic_table();
    },

    closeFilterForm() {
      this.show_form_filter = false;
    },

    close_table() {
      this.show_equip = false;
      this.show_tpa = false;
      this.show_gps = false;
      this.show_comp = false;
    },

    close_generic_table() {
      if (this.show_generic_table) {
        //this.show_generic_table=false;
        document.getElementById("right_form").style.display = "flex";
      }
      this.show_generic_table = false;
    },
    triggerAction(action) {
      if (action.action === "create_equipamento") {
        this.create_equipamento_ = true;
        this.form_title = "Criar equipamento";
        this.setEquipamentoForm(null);
        this.close_generic_table();
        this.show_form_equip = true;
        this.precoEquipamento = {
          compraMin: 0,
          compraMed: 0,
          compraAtual: 0,
          vendaMin: 0,
          venda: 0,
          equipamento_id: 0,
          status: "ativo",
        };
      } else if (action.action === "create_tpa") {
        this.create_tpa_ = true;
        this.form_title = "Criar Tpa";
        this.setTpaForm(null);
        this.close_generic_table();
        this.show_form_tpa = true;
      } else if (action.action === "create_gps") {
        console.log("Entra GPS")
        this.create_gps_ = true;
        this.form_title = "Criar Gps";
        this.setGpsForm(null);
        this.close_generic_table();
        this.show_form_gps = true;
      } else if (action.action === "create_computador") {
        this.create_comp_ = true;
        this.form_title = "Criar Computador";
        this.setCompForm(null);
        this.close_generic_table();
        this.show_form_comp = true;
      }
    },

    async create(data, url) {
      try {
        const res = await axios.post(url, data);
        console.log("CREATE", res)
        this.resp_status = res.data.status;
        this.resp_msg = res.data.message;
        return res.data.data;
      } catch (error) {
        this.resp_status = error.response.status;
        this.resp_msg = error.response.message;
        console.error("Error getting data:", error);
        throw error; // Rethrow the error to be handled by the caller
      }
    },

    async select(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;
      } catch (error) {
        console.error("Error getting data:", error);
      }
    },
    async select_all(url) {
      try {
        const res = await axios.get(url);
        return res.data.data;

      } catch (error) {
        console.error("Error getting data:", error);
      }

    },
    async update(url, data) {

      try {
        const res = await axios.put(url, data);
        this.resp_status = res.data.status;
        this.resp_msg = res.data.message;
        return res.data.data;

      } catch (error) {
        // Guarda o motivo devolvido pelo backend para quem chamou poder mostrá-lo
        this.resp_status = error.response?.status || 0;
        this.resp_msg = error.response?.data?.message || error.message;
        console.error("Error posting data:", error);
      }
    },

    filterObjectKeys(array, keys) {
      if (!array) return [];
      return array.map((obj) =>
        Object.fromEntries(
          Object.entries(obj).filter(([key]) => keys.includes(key))
        )
      );
    },


    setGpsForm(data) {
      console.log("GPS Data", data)
      this.gps_formData = {
        id: data && data.id ? data.id : 0,
        nome: data && data.nome ? data.nome : '',
        modelo: data && data.modelo ? data.modelo : '',
        ip: data && data.ip ? data.ip : '',
        simCard: data && data.simCard ? data.simCard : '',
        tipoComm: data && data.tipoComm ? data.tipoComm : '',
        status: data && data.status ? data.status : "ativo",
      };

      this.gps_setData = {
        viatura: data && data.viatura ? data.viatura : { id: 0, matricula: '' },
      };
      console.log("GPS FormData", this.gps_formData)
      console.log("GPS SetData", this.gps_setData)
    },

    setTpaForm(data) {
      console.log("TPA Data", data)
      this.tpa_formData = {
        id: data && data.id ? data.id : 0,
        serie: data && data.serie ? data.serie : '',
        modelo: data && data.modelo ? data.modelo : '',
        banco: data && data.banco ? data.banco : '',
        danos: data && data.danos ? data.danos : '',
        simCard: data && data.simCard ? data.simCard : '',
        status: data && data.status ? data.status : "ativo",
      };

      this.tpa_setData = {
        utilizador: data && data.utilizador ? data.utilizador : { id: 0, nome: '' },
      };
      console.log("Tpa FormData", this.tpa_formData)
      console.log("Tpa SetData", this.tpa_setData)
    },

    setCompForm(data) {
      this.comp_formData = {
        id: data && data.id ? data.id : 0,
        codigo: data && data.codigo ? data.codigo : '',
        modelo: data && data.modelo ? data.modelo : '',
        ip: data && data.ip ? data.ip : '',
        simCard: data && data.simCard ? data.simCard : '',
        tipoComm: data && data.tipoComm ? data.tipoComm : '',
        status: data && data.status ? data.status : "ativo",
      };

      this.comp_setData = {
        utilizador: data && data.status ? data.utilizador : { id: 0, nome: '' },
      };
    },

    setEquipamentoForm(data) {
      const isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;
      let newData = data;
      let customDecription = "";
      const validateData = (data, campo) => {
        if (!data) {
          return;
        }
        try {
          data[campo] = data[campo].toUpperCase();
        } catch (error) {
          console.log("error ao fazer uppercase da data:", error);
        }
        let invalidData = [
          "N/A",
          "sem marca".toUpperCase(),
          "sem medida".toUpperCase(),
          "sem tipologia".toUpperCase(),
          "sem produto".toUpperCase(),
          "sem familia".toUpperCase(),
        ];
        if ((data && invalidData.includes(data[campo])) || !data[campo]) {
          return "";
        }
        return data[campo];
      };
      if (data) {
        if (!data?.descricao || data?.descricao == "") {
          customDecription = `${validateData(data?.produto, "produto")} ${validateData(data?.tipologia, "nome")} ${validateData(data?.medida, "nome")} ${validateData(data?.marca, "nome")}`;
          customDecription = customDecription.replace(/\s+/g, " ").trim();
        } else {
          customDecription = data?.descricao;
        }
      } else {
        console.log("NÃO TEM DATA");
      }

      this.equipamento_formData = {
        id: data && data.id ? data.id : 0,
        codigo: data && data.codigo ? data.codigo : "",
        nome: data && data.nome ? data.nome : "",
        descricao: customDecription,
        referencia: data && data.referencia ? data.referencia : "N/A",
        foto: data && data.foto ? data.foto : require("@/assets/car_logo.svg"),
        status: data && data.status ? data.status : "ativo",
      };

      this.equipamento_setData = {
        familia: data && data.familia && !isEmptyObject(data?.nome) ? data.familia : {},
        produto: data && data.produto && !isEmptyObject(data?.produto) ? data.produto : {},
        tipologia: data && data.tipologia && !isEmptyObject(data?.tipologia) ? data.tipologia : {},
        marca: data && data.marca && !isEmptyObject(data?.marca) ? data.marca : {},
        preco: data && data.preco && !isEmptyObject(data?.preco) ? data.preco : {},
        medida: data && data.medida && !isEmptyObject(data?.medida) ? data.medida : {},
        servico: data && data.servico && !isEmptyObject(data?.servico) ? data.servico : {},
      };
    },

    setEquipamentoData(data) {
      let prepared_data = {
        codigo: data.codigo || "",
        nome: data.nome || "",
        descricao: data.descricao || "",
        referencia: data.referencia || "",
        familia_id: data?.familia?.id || 0,
        produto_id: data?.produto?.id || 0,
        tipologia_id: data?.tipologia?.id || 0,
        tpMedida_id: data?.medida?.id || 0,
        tpMarca_id: data?.marca?.id || 0,
        tpServico_id: data?.servico?.id || 0,
      };
      return prepared_data;
    },

    setGpsData(data) {
      let prepared_data = {
        nome: data.nome || "",
        modelo: data.modelo || "",
        tipoComm: data.tipoComm || "",
        ip: data?.ip || "",
        simCard: data?.simCard || "",
        viatura_id: data?.viatura?.id || 0,
        status: data?.status || "",
      };
      return prepared_data;
    },

    setTpaData(data) {
      let prepared_data = {
        serie: data.serie || "",
        banco: data.banco || "",
        danos: data.danos || "",
        modelo: data?.modelo || "",
        simCard: data?.simCard || "",
        utilizador_id: data?.utilizador?.id || 0,
        status: data?.status || "",
      };
      return prepared_data;
    },

    setCompData(data) {
      let prepared_data = {
        codigo: data?.codigo || "",
        modelo: data?.modelo || "",
        tipoComm: data?.tipoComm || "",
        ip: data?.ip || "",
        simCard: data?.simCard || "",
        utilizador_id: data?.utilizador?.id || 0,
        status: data?.status || "",
      };
      return prepared_data;
    },

    async disable_gps(data) {
      let url = "";
      if (data.status === "ativo") {
        url = `${this.baseURl}/api/v1/gps/eliminar/${data.id}/`;

      } else {
        url = `${this.baseURl}/api/v1/gps/eliminar/${data.id}/?ativar=true/`;

      }
      try {
        const res = await axios.delete(url);
        const message = data.status === "ativo" ? "desativado" : "ativado";
        this.gps_formData.status = this.gps_formData.status === "ativo" ? "desativado" : "ativo";

        this.refresh_table = true;
        toast.success(`gps ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.show_form_gps = true;
      } catch (error) {
        console.error("Erro a desativar gps:", error)
        let errorMessage = `Erro ao ${data.status === "ativo" ? "desativar" : "ativar"} gps`;
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage, {
          autoClose: 1000,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },

    async disable_tpa(data) {
      let url = "";
      if (data.status === "ativo") {
        url = `${this.baseURl}/api/v1/tpa/eliminar/${data.id}/`;

      } else {
        url = `${this.baseURl}/api/v1/tpa/eliminar/${data.id}/?ativar=true/`;

      }
      try {
        const res = await axios.delete(url);
        const message = data.status === "ativo" ? "desativado" : "ativado";
        this.tpa_formData.status = this.tpa_formData.status === "ativo" ? "desativado" : "ativo";

        this.refresh_table = true;
        toast.success(`tpa ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.show_form_tpa = true;
      } catch (error) {
        console.error("Erro a desativar tpa:", error)
        let errorMessage = `Erro ao ${data.status === "ativo" ? "desativar" : "ativar"} tpa`;
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage, {
          autoClose: 1000,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },

    async disable_comp(data) {
      let url = "";
      if (data.status === "ativo") {
        url = `${this.baseURl}/api/v1/computador/eliminar/${data.id}/`;

      } else {
        url = `${this.baseURl}/api/v1/computador/eliminar/${data.id}/?ativar=true/`;

      }
      try {
        const res = await axios.delete(url);
        const message = data.status === "ativo" ? "desativado" : "ativado";
        this.comp_formData.status = this.comp_formData.status === "ativo" ? "desativado" : "ativo";

        this.refresh_table = true;
        toast.success(`computador ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        this.show_form_comp = true;
      } catch (error) {
        console.error("Erro a desativar Computador:", error)
        let errorMessage = `Erro ao ${data.status === "ativo" ? "desativar" : "ativar"} computador`;
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage, {
          autoClose: 1000,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },

    async disable_equipamento(data) {
      let url = "";
      if (data.status === "ativo") {
        url = `${this.baseURl}/api/v1/equipamento/eliminar/${data.id}/`;
      } else {
        url = `${this.baseURl}/api/v1/equipamento/eliminar/${data.id}/?ativar=true/`;
      }
      try {
        const res = await axios.delete(url);
        console.log("equipamento updated", res.status);
        const message = data.status === "ativo" ? "desativado" : "ativado";
        this.refresh_table = true;
        this.refreshTable();
        toast.success(`equipamento ${message} com sucesso`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
        });
        const equipamento = await this.select(`${this.baseURl}/api/v1/equipamento/${data.id}/`);
        if (equipamento) {
          this.setEquipamentoForm(equipamento);
          this.show_form_equip = true;
        }
      } catch (error) {
        console.error("Erro a desativar Equipamento:", error)
        let errorMessage = `Erro ao ${data.status === "ativo" ? "desativar" : "ativar"} equipamento`;
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage, {
          autoClose: 1000,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },
  },

  watch: {
    refresh_table(newVal) { },
  },
};
</script>

<style scoped>
.scroll-style {
  overflow-y: auto;
  scrollbar-color: gray transparent;
  scrollbar-width: thin;

}

.p-confirm-popup {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* Align to the top */
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  height: auto;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  padding-top: 2rem;
  /* Add some padding to the top */
  margin-top: 8px;
  background: #626288;
  color: white;
  border: 0 none;
  border-radius: 10px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
}

.p-confirm-popup-content {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  width: 300px;
  text-wrap: wrap;
}

.p-confirm-popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
}

.p-button {
  font-size: 14px;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
}

.p-confirm-popup-reject {
  background-color: rgba(255, 0, 0, 0.792);
  color: white;
}

.p-confirm-popup-accept {
  background-color: rgb(255, 155, 5);
  color: white;
}

/* Triangle Pointer */
.triangle-pointer {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid #626288;
  position: absolute;
  left: 15%;
  transform: translateX(-50%);
  top: -10px;
}

.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}

.btn:hover {
  background-color: var(--icon) !important;
}
</style>
